import { render, staticRenderFns } from "./FollowerGoalSettingsContent.vue?vue&type=template&id=063d072a&scoped=true"
import script from "./FollowerGoalSettingsContent.vue?vue&type=script&lang=js"
export * from "./FollowerGoalSettingsContent.vue?vue&type=script&lang=js"
import style0 from "./FollowerGoalSettingsContent.vue?vue&type=style&index=0&id=063d072a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063d072a",
  null
  
)

export default component.exports